"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _framerMotion = require("framer-motion");

var _gridContainer = _interopRequireDefault(require("./grid-container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* 
  A helper function for setting background position based on incoming string.
  This is a legacy mapping for options in the Contentful Model for background position.
  We may want to reconsider and split this out into position and alignment props.
*/
var setBackgroundPosition = function setBackgroundPosition(position) {
  switch (position) {
    case 'alignTop':
      {
        return 'top center';
      }

    case 'alignBottom':
      {
        return 'bottom center';
      }

    case 'alignRight':
      {
        return 'right';
      }

    case 'alignRightTop':
      {
        return 'right top';
      }

    case 'alignLeft':
      {
        return 'left';
      }

    case 'alignLeftTop':
      {
        return 'left top';
      }

    case 'alignLeftBottom':
      {
        return 'left bottom';
      }

    default:
      {
        return 'center';
      }
  }
};

var Background = (0, _styledComponents["default"])('div').withConfig({
  displayName: "grid-container-with-background__Background",
  componentId: "sc-45j624-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;", " background-image:", ";background-position:", ";background-repeat:", ";background-size:", ";overflow:hidden;pointer-events:none;z-index:-1;@media ", "{background-image:", ";background-position:", ";background-repeat:", ";background-size:", ";", "}"], function (props) {
  return (0, _css["default"])({
    backgroundColor: props.backgroundColorMobile || 'backgrounds.gray'
  });
}, function (props) {
  return props.backgroundImageMobile ? "url(".concat(props.backgroundImageMobile, "?w=800").concat(props.resizeImage ? '&fm=jpg&fl=progressive&q=70' : '', ")") : '';
}, function (props) {
  return setBackgroundPosition(props.backgroundImagePositionMobile || props.backgroundImagePosition);
}, function (props) {
  return props.backgroundRepeatMobile || 'no-repeat';
}, function (props) {
  return props.backgroundSizeMobile || 'auto';
}, function (props) {
  return props.theme.queries.desktopAndUp;
}, function (props) {
  return props.videoPresent ? 'none' : "url(".concat(props.backgroundImage).concat(props.resizeImage ? '?fm=jpg&fl=progressive&q=70' : '', ")");
}, function (props) {
  return setBackgroundPosition(props.backgroundImagePosition);
}, function (props) {
  return props.backgroundRepeat || 'no-repeat';
}, function (props) {
  return props.backgroundSize || 'auto';
}, function (props) {
  return (0, _css["default"])({
    backgroundColor: props.backgroundColor || 'backgrounds.gray'
  });
});
var Overlay = (0, _styledComponents["default"])('div').withConfig({
  displayName: "grid-container-with-background__Overlay",
  componentId: "sc-45j624-1"
})(["position:absolute;top:0;right:0;bottom:0;left:0;background-color:", ";pointer-events:none;"], function (props) {
  return props.theme.utils.getHexOpacity(props.theme.colors.black, props.opacity);
});
var Video = (0, _styledComponents["default"])('video').withConfig({
  displayName: "grid-container-with-background__Video",
  componentId: "sc-45j624-2"
})(["display:none;position:absolute;top:0;right:0;bottom:0;left:0;object-fit:cover;@media ", "{display:block;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
/**
 * This component creates a GridComponent with a background-image, pattern, or video.
 * In addition, it also provides an overlay gradient.
 * 
 * @param {string} backgroundColor - Overrides the default (slate.lightest) background-color.
 * @param {string} backgroundColorMobile - Overrides the default (slate.lightest) background-color.
 * @param {string} backgroundImage - The url for the background image
 * @param {string} backgroundImageMobile - The url for the background image on mobile
 * @param {string} backgroundImagePosition - The image's positioning (see setBackgroundPosition)
 * @param {string} backgroundImagePositionMobile - The image's positioning on mobile (see setBackgroundPosition)
 * @param {string} backgroundRepeat - Repeat the image on desktop
 * @param {string} backgroundRepeatMobile - Repeat the image on mobile
 * @param {string} backgroundSize - corresponds to background-size on desktop
 * @param {string} backgroundSizeMobile - corresponds to background-size on mobile
 * @param {number} overlayOpacity - Set the desired overlay opacity
 * @param {boolean} resizeImage - Whether the background image should be resized via Contentful query params 
 *  NB: this will convert the image to a jpg, and therefore it will lose any transparency.
 * @param {boolean} showOverlay - Whether to show the darkening overlay (default: true)
 * @param {array} videos - An array of video objects retrieved from contentful
 * @returns {React.element}
 */

var GridContainerWithBackground = function GridContainerWithBackground(_ref) {
  var backgroundColor = _ref.backgroundColor,
      backgroundColorMobile = _ref.backgroundColorMobile,
      backgroundImage = _ref.backgroundImage,
      backgroundImageMobile = _ref.backgroundImageMobile,
      backgroundImagePosition = _ref.backgroundImagePosition,
      backgroundImagePositionMobile = _ref.backgroundImagePositionMobile,
      backgroundSize = _ref.backgroundSize,
      backgroundSizeMobile = _ref.backgroundSizeMobile,
      backgroundRepeat = _ref.backgroundRepeat,
      backgroundRepeatMobile = _ref.backgroundRepeatMobile,
      resizeImage = _ref.resizeImage,
      _ref$videos = _ref.videos,
      videos = _ref$videos === void 0 ? [] : _ref$videos,
      _ref$showOverlay = _ref.showOverlay,
      showOverlay = _ref$showOverlay === void 0 ? true : _ref$showOverlay,
      _ref$overlayOpacity = _ref.overlayOpacity,
      overlayOpacity = _ref$overlayOpacity === void 0 ? 25 : _ref$overlayOpacity,
      children = _ref.children,
      delegated = _objectWithoutProperties(_ref, ["backgroundColor", "backgroundColorMobile", "backgroundImage", "backgroundImageMobile", "backgroundImagePosition", "backgroundImagePositionMobile", "backgroundSize", "backgroundSizeMobile", "backgroundRepeat", "backgroundRepeatMobile", "resizeImage", "videos", "showOverlay", "overlayOpacity", "children"]);

  var shouldReduceMotion = (0, _framerMotion.useReducedMotion)();
  return /*#__PURE__*/_react["default"].createElement(_gridContainer["default"], delegated, /*#__PURE__*/_react["default"].createElement(Background, {
    backgroundColor: backgroundColor,
    backgroundColorMobile: backgroundColorMobile || backgroundColor,
    backgroundImage: backgroundImage,
    backgroundImageMobile: backgroundImageMobile || backgroundImage,
    backgroundImagePosition: backgroundImagePosition,
    backgroundImagePositionMobile: backgroundImagePositionMobile || backgroundImagePosition,
    backgroundRepeat: backgroundRepeat,
    backgroundRepeatMobile: backgroundRepeatMobile || backgroundRepeat,
    backgroundSize: backgroundSize,
    backgroundSizeMobile: backgroundSizeMobile,
    resizeImage: resizeImage,
    videoPresent: Boolean(videos.length) && !shouldReduceMotion
  }, Boolean(videos.length) && !shouldReduceMotion ? /*#__PURE__*/_react["default"].createElement(Video, {
    playsInline: true,
    autoPlay: true,
    loop: "loop",
    muted: true,
    width: "100%",
    height: "100%"
  }, videos.map(function (video) {
    return /*#__PURE__*/_react["default"].createElement("source", {
      key: video.fields.file.contentType,
      src: video.fields.file.url,
      type: video.fields.file.contentType
    });
  })) : null), showOverlay && /*#__PURE__*/_react["default"].createElement(Overlay, {
    opacity: overlayOpacity
  }), children);
};

GridContainerWithBackground.propTypes = {
  backgroundColor: _propTypes["default"].string,
  backgroundColorMobile: _propTypes["default"].string,
  backgroundImage: _propTypes["default"].string,
  backgroundImageMobile: _propTypes["default"].string,
  backgroundImagePosition: _propTypes["default"].string,
  backgroundImagePositionMobile: _propTypes["default"].string,
  backgroundRepeat: _propTypes["default"].string,
  backgroundRepeatMobile: _propTypes["default"].string,
  backgroundSize: _propTypes["default"].string,
  backgroundSizeMobile: _propTypes["default"].string,
  overlayOpacity: _propTypes["default"].number,
  resizeImage: _propTypes["default"].bool,
  showOverlay: _propTypes["default"].bool,
  videos: _propTypes["default"].arrayOf(_propTypes["default"].object) // TODO: create PropType for videos array.

};
var _default = GridContainerWithBackground;
exports["default"] = _default;